import { render } from "./HermesSpreadsheetWorkbookTabs.vue?vue&type=template&id=a072241a&scoped=true"
import script from "./HermesSpreadsheetWorkbookTabs.vue?vue&type=script&lang=js"
export * from "./HermesSpreadsheetWorkbookTabs.vue?vue&type=script&lang=js"

import "./HermesSpreadsheetWorkbookTabs.vue?vue&type=style&index=0&id=a072241a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a072241a"]])

export default __exports__